"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAdminTableCells = exports.generatePublisherTableCells = void 0;
const CellInput_1 = __importDefault(require("@Components/ViewWork/Table/ValidationCells/CellInput"));
const permission_1 = require("@App/helpers/permission");
const Button_1 = require("@Components/Buttons/Button");
const CellDisplayList_1 = __importDefault(require("@Components/ViewWork/Table/ValidationCells/CellDisplayList"));
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const usePublisherService_1 = __importDefault(require("@App/services/usePublisherService"));
const generatePublisherTableCells = ({ publisher, index, getKeyPrefix, }) => {
    var _a, _b;
    const { publisherStepStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const publisherService = (0, usePublisherService_1.default)();
    return [
        react_1.default.createElement(CellInput_1.default, { defaultValue: publisher.publisherName, readOnly: true, name: `rows.publisherRows[${index}].publisherName`, key: `${getKeyPrefix(publisher)}.publisherName`, type: 'text' }),
        react_1.default.createElement(CellInput_1.default, { name: `rows.publisherRows[${index}].publisherIPI`, key: `${getKeyPrefix(publisher)}.publisherIPI`, defaultValue: (_a = publisher.ipiNumber) !== null && _a !== void 0 ? _a : '', readOnly: true, type: 'text' }),
        react_1.default.createElement(CellInput_1.default, { name: `rows.publisherRows[${index}].publisherIPINumber`, key: `${getKeyPrefix(publisher)}.publisherIPINumber`, defaultValue: (_b = publisher.hfaPublisherNumber) !== null && _b !== void 0 ? _b : '', readOnly: true, type: 'text' }),
        react_1.default.createElement(CellInput_1.default, { name: `rows.publisherRows[${index}].publisherShare`, key: `${getKeyPrefix(publisher)}.publisherShare`, defaultValue: publisher.publisherShare, min: 0, max: 100.06, type: 'number', readOnly: !(0, permission_1.canAmend)(publisher.amend) || publisher.administratorPublishers.length > 0, onValueChanged: (value) => {
                publisherService.updatePublisherShare(publisher, value);
            } }),
        react_1.default.createElement(Button_1.Button, { className: 'add-administrator-button', key: `${getKeyPrefix(publisher)}-add-admin-button`, type: 'primary', mainColor: true, onClick: () => {
                publisherStepStore.initAddAP(publisher);
            }, disabled: !(0, permission_1.canAmend)(publisher.amend) }, "Add"),
        react_1.default.createElement(CellDisplayList_1.default, { readOnly: !(0, permission_1.canAmend)(publisher.amend), key: `${getKeyPrefix(publisher)}-display-list`, items: publisher.writers, onAddToListClicked: () => {
                publisherStepStore.initAddWriterToOriginalPublisher(publisher);
            }, onRemoveFromListClicked: (writerModel) => {
                publisherService.removeLinkedWriter(publisher, writerModel);
            } }),
    ];
};
exports.generatePublisherTableCells = generatePublisherTableCells;
const generateAdminTableCells = ({ admin, publisher, index, getKeyPrefix, }) => {
    const publisherService = (0, usePublisherService_1.default)();
    return [
        react_1.default.createElement(CellInput_1.default, { defaultValue: admin.publisherName, readOnly: true, name: `rows.administratorRows[${index}].administrator`, key: `${getKeyPrefix(admin)}.administrator`, type: 'text' }),
        react_1.default.createElement(CellInput_1.default, { name: `rows.administratorRows[${index}].administratorIPI`, key: `${getKeyPrefix(admin)}.administratorIPI`, defaultValue: admin.ipiNumber, readOnly: true, type: 'text' }),
        react_1.default.createElement(CellInput_1.default, { name: `rows.administratorRows[${index}].administratorIPINumber`, key: `${getKeyPrefix(admin)}.administratorIPINumber`, defaultValue: admin.hfaPublisherNumber, readOnly: true, type: 'text' }),
        react_1.default.createElement(CellInput_1.default, { name: `rows.administratorRows[${index}].administratorShare`, key: `${getKeyPrefix(admin)}.administratorShare`, defaultValue: admin.publisherShare, min: 0.0, max: 100.06, type: 'number', readOnly: !(0, permission_1.canAmend)(admin.amend), onValueChanged: (value) => {
                publisherService.updateAdministratorPublisherShare(publisher, admin, value);
            } }),
    ];
};
exports.generateAdminTableCells = generateAdminTableCells;
